import React from 'react';
import PropTypes from 'prop-types';
import makeRequest from 'utils/makeRequest';
import Card from 'components_v2/common/CardV2';
import InViewObserver from 'components/InViewObserver/InViewObserver';
import InterSectionBorder from 'components_v2/common/InterSectionBorder';
import Listingheader from '../../common/ListingheaderV2';
import analyticsWrapper from '../../../../../helpers/analytics/analyticsWrapper';

// import s from './CartoonInfo.scss';

class CartoonInfo extends React.Component {
  constructor() {
    super();
    this.state = {};
  }
  loadSection = () => {
    const { data } = this.props;
    if (data && data.dataUrl) {
      this.loadSectionData(data.dataUrl);
    }
  };

  loadSectionData = dataUrl => {
    if (!dataUrl) {
      return;
    }

    makeRequest
      .get(dataUrl, { isMobile: false }, 'skipfeedengine')
      .then(data => {
        if (
          data &&
          data.data &&
          data.data.items &&
          data.data.items.length > 0
        ) {
          //console.log('data : ', data.data);
          this.setState({
            data: { ...this.props.data, ...data.data },
          });
        }
      });
  };
  render() {
    const data = this.state.data || this.props.data;
    const { ga4Type, ga4Category } = this.props;

    const scrollGAAttr = {
      ...(data.onScrollGA && data.id && { 'data-scrollga': data.id }),
    };

    return (
      <InViewObserver
        inViewCallback={() => {
          this.loadSection();
          if (typeof ga4Type !== 'undefined' && ga4Type !== '') {
            analyticsWrapper('ga4', {
              event: 'user_shown',
              type: ga4Type,
              category: ga4Category,
            });
          }
        }}
        viewMargin="400px 0px 400px 0px"
      >
        {Array.isArray(data.items) && (
          <>
            {data.border === 'top' && (
              <InterSectionBorder border={data.border} />
            )}
            <div className="row" {...scrollGAAttr}>
              {data.items.map(node => (
                <div className="col_l_6 col_m_12">
                  <Listingheader
                    headingname={node.name}
                    headingLink={node.link || node.path}
                    //size="small"
                    newga={`${node.name}Section_Actions#HeadingClick`}
                    target={node.target}
                    ga4Type={node?.ga4Type ? node?.ga4Type : ga4Type}
                    ga4Category={
                      node?.ga4Category ? node?.ga4Category : ga4Category
                    }
                  />
                  <div className="row">
                    {node.items instanceof Array
                      ? node.items.map((item, index) => (
                          <div className="col_l_4">
                            <Card
                              data={item}
                              isVerticalTile
                              key={item.id || `${item.tn}_${index}`}
                              newga={`${
                                node.name
                              }Section_Actions#$typeClick-${index}/${item.wu}`}
                              ga4Type={node?.ga4Type ? node?.ga4Type : ga4Type}
                              ga4Category={
                                node?.ga4Category
                                  ? node?.ga4Category
                                  : ga4Category
                              }
                              gaIndex={index + 1}
                            />
                          </div>
                        ))
                      : null}
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </InViewObserver>
    );
  }
}

CartoonInfo.propTypes = {
  data: PropTypes.shape({}),
  ga4Category: PropTypes.string,
  ga4Type: PropTypes.string,
};
CartoonInfo.defaultProps = {
  data: {},
  ga4Type: '',
  ga4Category: '',
};

export default CartoonInfo;
